<template>
  <div id="shared-armor-detail">
    <div class="row">
      <div class="col-2 text-center">
        <under-input v-model.number="armorClass.bonus" maxlength="2">
          Bonus
        </under-input>
      </div>
      <div class="col">
        <under-input v-model.trim="armorClass.description">
          <slot></slot>
        </under-input>
      </div>
    </div>
  </div>
</template>
<script>
import UnderInput from "../../shared/_UnderInput.vue";

export default {
  name: "sheet-defense-details-armor-detail",
  components: {
    UnderInput
  },
  props: ["armorClass"]
};
</script>
